import pt from './pt-BR';
import en from './en-US';
import es from './es-ES';

export default {
    ...pt,
    ...en,
    ...es
};
